import { render, staticRenderFns } from "./TagComponent.vue?vue&type=template&id=09b99eae&scoped=true&"
import script from "./TagComponent.vue?vue&type=script&lang=js&"
export * from "./TagComponent.vue?vue&type=script&lang=js&"
import style0 from "./TagComponent.vue?vue&type=style&index=0&id=09b99eae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b99eae",
  null
  
)

export default component.exports